<template>
  <div class="modal-container clearfix">
    <div class="add-box clearfix">
      <table-header @add="insertEvent" @remove="removeEvent" @copy="paste"></table-header>
      <vxe-table
          border
          show-overflow
          ref="xTable"
          class="table-style"
          max-height="450"
          :auto-resize="true"
          align="center"
          :data="tableData"
          :edit-rules="tableRules"
          :edit-config="{trigger: 'click', mode: 'cell'}"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
          @scroll="clearTableV"
      >
        <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
        <vxe-table-column field="no" title="序号" width="60"></vxe-table-column>
        <vxe-table-column field="realName" title="姓名" width="150">
          <template v-slot:header>
            <span style="color: red">*</span>姓名
          </template>
          <template v-slot="scope">
            <vxe-input v-model="scope.row.realName" placeholder="必填" @blur="clearTableV"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="regisiterNum" title="注册手机号" width="150">
          <template v-slot:header>
            <span style="color: red">*</span>注册手机号
          </template>
          <template v-slot="scope">
            <vxe-input v-model="scope.row.regisiterNum" placeholder="必填"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="idcardNum" title="身份证号码" width="150">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.idcardNum" placeholder="选填"
                       @input="inputId(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="idCardExpireTime" title="身份证有效期至" width="150">
          <template v-slot="scope">
            <vxe-input type="date" v-model="scope.row.idCardExpireTime"
                       placeholder="选填" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="phoneNum" title="备用联系方式" width="150">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.phoneNum" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="driverCardNum" title="驾驶证号" width="150">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.driverCardNum" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)" disabled></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="driverModel" title="准驾车型" width="150">
          <template v-slot="scope">
            <vxe-select
                v-model="scope.row.driverModel"
                placeholder="请选择"
                :options="driver_model"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="issueAuthority" title="驾驶证发证机关" width="150">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.issueAuthority" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="driverBeginTime" title="驾驶证有效期自" width="150">
          <template v-slot="scope">
            <vxe-input type="date" v-model="scope.row.driverBeginTime"
                       placeholder="选填" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="driverExpireTime" title="驾驶证有效期至" width="150">
          <template v-slot="scope">
            <vxe-input type="date" v-model="scope.row.driverExpireTime"
                       placeholder="选填" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="weightType" title="所驾驶车辆总重量" width="150">
          <template v-slot="scope">
            <vxe-select
                v-model="scope.row.weightType"
                placeholder="请选择"
                :options="weight_type"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="transportLicenseNum" title="从业资格证号" width="150">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.transportLicenseNum" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)" disabled></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="transportExpireTime" title="从业资格证有效期至" width="150">
          <template v-slot="scope">
            <vxe-input type="date" v-model="scope.row.transportExpireTime"
                       placeholder="选填" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="idcardFrontUrl" title="身份证正面" width="150">
          <template v-slot="scope">
            <upload-img :row="scope.row" :fileKey="'idcardFrontUrl'"
                        :initFile="scope.row.idcardFrontUrl"></upload-img>
          </template>
        </vxe-table-column>
        <vxe-table-column field="idcardBackUrl" title="身份证反面" width="150">
          <template v-slot="scope">
            <upload-img :row="scope.row" :fileKey="'idcardBackUrl'"
                        :initFile="scope.row.idcardBackUrl"></upload-img>
          </template>
        </vxe-table-column>
        <vxe-table-column field="drivingCardFrontUrl" title="驾驶证正面" width="150">
          <template v-slot="scope">
            <upload-img :row="scope.row" :fileKey="'drivingCardFrontUrl'"
                        :initFile="scope.row.drivingCardFrontUrl"></upload-img>
          </template>
        </vxe-table-column>
        <vxe-table-column field="drivingCardSubpageUrl" title="驾驶证副面" width="150">
          <template v-slot="scope">
            <upload-img :row="scope.row" :fileKey="'drivingCardSubpageUrl'"
                        :initFile="scope.row.drivingCardSubpageUrl"></upload-img>
          </template>
        </vxe-table-column>
        <vxe-table-column field="qualificationUrl" title="从业资格证" width="150">
          <template v-slot="scope">
            <upload-img :row="scope.row" :fileKey="'qualificationUrl'"
                        :initFile="scope.row.qualificationUrl"></upload-img>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button status="primary" @click="impotEvent">上传导入文件</Button>
      <Button status="primary" @click="commit">保 存</Button>
    </div>
    <vxe-modal v-model="messageVisible" title="消息提示" width="600" height="350" @close="closeMessage" remember>
      <Message ref="messageModal" @close="closeMessage"></Message>
    </vxe-modal>
  </div>
</template>

<script>
import $api from '@/apiProvider';
import XLSX from "xlsx";
import Message from "@/components/common/Message";
import {getExcelTime, showLoading, hideLoading, isEmpty} from '@/utils/util';
import TableHeader from "../../components/common/TableHeader";
import md5 from "js-md5";
import UploadImg from "@/components/common/UploadImg";

export default {
  components: {Message, TableHeader, UploadImg},
  data() {
    return {
      userCategoryData: {
        options: []
      },
      tableData: [{
        no: 1,
        userCategoryStr: '司机',
        userName: null,
        realName: null,
        idcardNum: null,
        regisiterNum: null,
        phoneNum: null,
        password: md5("888999"),
        userType: 1,
      }],
      tableRules: {
        userName: [
          {required: true, message: "请输入客户名称"},
          {max: 20, message: '客户名称不能超过20个字符'}
        ],
        userCategoryStr: [
          {required: true, message: "请选择身份类型"}
        ],
        realName: [
          {required: true, message: "请输入姓名"},
          {max: 20, message: '姓名不能超过20个字符'}
        ],
        idcardNum: [
          {min: 18, max: 18, message: '请输入正确的身份证号码'},
          {validator: this.requireValid}
        ],
        regisiterNum: [
          {required: true, message: "请输入注册手机号"},
          {min: 11, max: 11, message: '请输入正确的手机号'},
          {validator: this.requireValid}
        ],
        phoneNum: [
          {min: 11, max: 11, message: '请输入正确的联系方式'},
          {validator: this.requireValid}
        ],
        taxNum: [
          {min: 18, max: 18, message: '请输入正确的统一社会信用码'}
        ],
        transportLicenseNum: [
          {min: 18, max: 18, message: '请输入正确的从业资格证号码'}
        ],
      },
      messageVisible: false,
      message: '',
      records: [],
      userCategoryMap: new Map(),
      dict: [],
      driver_model: [],
      weight_type: [{
        label: '大于4.5吨',
        value: 1,
      }, {
        label: '小于等于4.5吨',
        value: 2,
      }],
    }
  },
  mounted() {
    this.getAllDict();
    this.getDicUserCategoryList();
    this.getDict(40500, 'driver_model');
  },
  methods: {
    inputId(scope) {
      scope.row.driverCardNum = scope.row.idcardNum;
      scope.row.transportLicenseNum = scope.row.idcardNum;
      this.$refs.xTable.updateStatus(scope);
    },
    requireValid(e) {
      if (e.column.title === '注册手机号' && !isEmpty(e.row.regisiterNum)) {
        let regPhone = new RegExp(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/);
        let validPhone = regPhone.test(e.row.regisiterNum);
        if (!validPhone) {
          return Promise.reject(new Error("请输入正确的手机号"));
        }
      }
      if (e.column.title === '身份证号码' && !isEmpty(e.row.idcardNum)) {
        let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
        let validIDre = _IDRe18.test(e.row.idcardNum) || _IDre15.test(e.row.idcardNum);
        if (!validIDre) {
          return Promise.reject(new Error("请输入正确的身份证号码"));
        }
      }
      if (e.column.title === '联系方式' && !isEmpty(e.row.phoneNum)) {
        let regPhone = new RegExp(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/);
        let validPhone = regPhone.test(e.row.phoneNum);
        if (!validPhone) {
          return Promise.reject(new Error("请输入正确的手机号"));
        }
      }
    },
    async getAllDict() {
      let res = await $api.dict.get("searchDic");
      if (res.status === 1) {
        this.dict = res.data;
      } else {
        this.$XModal.message(res.message);
      }
    },
    async getDict(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map(i => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          })
        })
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    getDicUserCategoryList() {
      var self = this
      self.userCategoryData = {options: []}
      self.userCategoryMap = new Map();
      $api.other.getDicUserCategoryModel
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              var obj = {
                label: item.dictText,
                value: item.dictCode
              }
              self.userCategoryData.options.push(obj);
              self.userCategoryMap.set(item.dictText, item.dictCode);
            });
          });
    },
    selectChangeEvent({checked, row}) {
      if (checked) {
        this.records.push(row);
      } else {
        let key = this.records.indexOf(row);
        this.records.splice(key, 1);
      }
    },
    selectAllEvent({checked, records}) {
      if (checked) {
        this.records = records;
      } else {
        this.records = [];
      }
    },
    closeMessage() {
      this.messageVisible = false;
    },
    impotEvent() {
      let self = this;
      this.$refs.xTable.readFile({
        types: ['xls', 'xlsx']
      }).then(evnt => {
        showLoading();
        const tableData = [];
        const files = evnt.target.files;
        const fileReader = new FileReader();
        fileReader.onload = async (ev) => {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {type: 'binary'});
          const csvData = XLSX.utils.sheet_to_csv(Object.values(workbook.Sheets)[0]);
          // 解析数据
          let xlsxData = csvData.split('\n');
          let phoneArr = [];
          //删除xlsx列名
          xlsxData.splice(0, 1);
          xlsxData.forEach((vRow) => {
            if (vRow) {
              const vCols = vRow.split(',');
              let driverModelText = vCols[6];
              let weightTypeText = vCols[10];
              let driverModel = '';
              let weightType = '';
              if (driverModelText && driverModelText !== '') {
                self.dict.map(i => {
                  if (i.dictText === driverModelText) {
                    driverModel = i.dictCode;
                  }
                })
              }
              if (weightTypeText && weightTypeText !== '') {
                if (weightTypeText === '大于4.5吨') {
                  weightType = 1;
                } else if (weightTypeText === '小于等于4.5吨') {
                  weightType = 2;
                } else {
                  weightType = null;
                }
              }
              const item = {
                no: vCols[0],
                userCategoryStr: '司机',
                realName: vCols[1],
                regisiterNum: vCols[2],
                idcardNum: vCols[3],
                idCardExpireTime: getExcelTime(vCols[4]),
                phoneNum: vCols[5],
                driverModel: driverModel,
                issueAuthority: vCols[7],
                driverCardNum: vCols[3],
                driverBeginTime: getExcelTime(vCols[8]),
                driverExpireTime: getExcelTime(vCols[9]),
                weightType: weightType,
                transportLicenseNum: vCols[3],
                transportExpireTime: getExcelTime(vCols[11]),
                password: md5("888999"),
                userType: 1,
              };

              if (vCols[2]) {
                phoneArr.push(vCols[2]);
              }

              tableData.push(item);
            }
          })

          let res = await $api.gcdUser.request("queryUserInfoClientDetailList", {loginNames: phoneArr});
          if (res.status === 1) {
            tableData.map(i => {
              res.data.map(j => {
                if (i.regisiterNum === j.loginName) {
                  if (!i.realName || i.realName === '') {
                    i.realName = j.realName;
                  }
                  if (!i.userCategoryStr || i.userCategoryStr === '') {
                    i.userCategoryStr = j.tagsStr;
                  }
                  if (!i.idcardNum || i.idcardNum === '') {
                    i.idcardNum = j.idcardNum;
                  }
                  if (!i.idCardExpireTime || i.idCardExpireTime === '') {
                    i.idCardExpireTime = this.$utils.toDateString(j.idCardExpireTime, 'yyyy-MM-dd');
                  }
                  if (!i.driverModel || i.driverModel === '') {
                    i.driverModel = j.driverModel;
                  }
                  if (!i.issueAuthority || i.issueAuthority === '') {
                    i.issueAuthority = j.issueAuthority;
                  }
                  if (!i.driverCardNum || i.driverCardNum === '') {
                    i.driverCardNum = j.driverCardNum;
                  }
                  if (!i.driverBeginTime || i.driverBeginTime === '') {
                    i.driverBeginTime = this.$utils.toDateString(j.driverBeginTime, 'yyyy-MM-dd');
                  }
                  if (!i.driverExpireTime || i.driverExpireTime === '') {
                    i.driverExpireTime = this.$utils.toDateString(j.driverExpireTime, 'yyyy-MM-dd');
                  }
                  if (!i.weightType || i.weightType === '') {
                    i.weightType = j.weightType;
                  }

                  if (!i.transportLicenseNum || i.transportLicenseNum === '') {
                    i.transportLicenseNum = j.transportLicenseNum;
                  }
                  if (!i.transportExpireTime || i.transportExpireTime === '') {
                    i.transportExpireTime = this.$utils.toDateString(j.transportExpireTime, 'yyyy-MM-dd');
                  }
                  if (!i.idcardFrontUrl || i.idcardFrontUrl === '') {
                    i.idcardFrontUrl = j.idcardFrontUrl;
                  }
                  if (!i.idcardBackUrl || i.idcardBackUrl === '') {
                    i.idcardBackUrl = j.idcardBackUrl;
                  }
                  if (!i.drivingCardFrontUrl || i.drivingCardFrontUrl === '') {
                    i.drivingCardFrontUrl = j.drivingCardFrontUrl;
                  }
                  if (!i.drivingCardSubpageUrl || i.drivingCardSubpageUrl === '') {
                    i.drivingCardSubpageUrl = j.drivingCardSubpageUrl;
                  }
                  if (!i.qualificationUrl || i.qualificationUrl === '') {
                    i.qualificationUrl = j.qualificationUrl;
                  }
                }
              })
            })
          }

          this.tableData = tableData;
        }
        fileReader.readAsBinaryString(files[0]);
        setTimeout(() => {
          hideLoading();
        }, 1000);
      })
    },
    async insertEvent() {
      let record = {
        no: this.$refs.xTable.data.length + 1,
        userName: null,
        userCategoryStr: '司机',
        realName: null,
        idcardNum: null,
        regisiterNum: null,
        phoneNum: null,
        password: md5("888999"),
        userType: 1,
      };
      this.pushIntoTable(record);
    },
    paste() {
      let records = this.records.sort((a, b) => a.no - b.no);
      if (records.length > 0) {
        records.map(i => {
          let record = Object.assign({}, i)
          record.no = this.$refs.xTable.data.length + 1;
          this.pushIntoTable(record);
        })
      } else {
        this.$XModal.message({status: "error", message: "请选择需要复制的信息！"});
      }
    },
    pushIntoTable(record) {
      let {row: newRow} = this.$refs.xTable.insertAt(record, -1);
      this.$refs.xTable.data.push(record);
      this.$refs.xTable.setActiveCell(newRow, "userName");
    },
    async validEvent() {
      let errMap = await this.$refs.xTable
          .validate()
          .catch((errMap) => errMap);
      return errMap ? false : true
    },
    removeEvent() {
      let records = this.records;
      if (records.length > 0) {
        if (this.$refs.xTable.tableData.length > 1) {
          this.$XModal.confirm("您确定要删除选中数据?").then((type) => {
            if (type === "confirm") {
              this.clearTableV()
              records.map(i => {
                this.$refs.xTable.remove(i);
                let key = this.$refs.xTable.data.indexOf(i);
                this.$refs.xTable.data.splice(key, 1);
              })
              this.records = [];
              if (this.isExport === false) {
                this.$refs.xTable.data.map((j, index) => {
                  j.no = index + 1;
                })
              }
            }
          });
        } else {
          this.$XModal.alert({
            message: "已经是最后一条了！",
            status: "warning",
          });
        }
      } else {
        this.$XModal.message({status: "error", message: "请选择需要删除的信息！"});
      }
    },
    clearTableV() {
      this.$refs.xTable.clearValidate();
    },
    async commit() {
      let sts = await this.validEvent()
      if (!sts) {
        this.$XModal.message({status: "error", message: "校验不通过！"});
        return
      }
      this.save();
    },
    async save() {
      showLoading();
      let arr = JSON.parse(JSON.stringify(this.tableData));
      arr.map(i => {
        if (i.userName) {
          i.userName = i.userName.trim();
        }
        if (i.realName) {
          i.realName = i.realName.trim();
        }
        if (i.idCardExpireTime) {
          i.idCardExpireTime = this.$utils.timestamp(i.idCardExpireTime);
        }
        if (i.driverBeginTime) {
          i.driverBeginTime = this.$utils.timestamp(i.driverBeginTime);
        }
        if (i.driverExpireTime) {
          i.driverExpireTime = this.$utils.timestamp(i.driverExpireTime);
        }
        if (i.transportExpireTime) {
          i.transportExpireTime = this.$utils.timestamp(i.transportExpireTime);
        }
      })
      let res = await $api.baseUserSign.request('batchCreateAndSaveBaseUserSignTwo', arr);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success('提交成功');
        this.close();
        this.$emit('afterSave');
        // this.batchWYMIdlephoneCheck(res.data.userList);
      } else {
        if (res.data) {
          let data = res.data.errorList;
          let message = '';
          if (data.length > 0) {
            data.map(i => {
              message = message + '序号' + (this.tableData[i.failArrayIndex].no) + '，' + i.failMsg + '\n';
            })
            // let errorData = []
            // data.forEach(failItem => {
            //   errorData.push(Object.assign({}, this.tableData[failItem.failArrayIndex]));
            // })
            // this.tableData = errorData;
          }
          if (message === '') {
            this.$XModal.alert({
              message: "接口异常",
              status: "error",
            });
          } else {
            this.$refs.messageModal.setMessage(message);
            this.messageVisible = true;
          }
        } else {
          this.$XModal.alert({
            message: res.message,
            status: "error",
          });
        }
      }
    },
    async batchWYMIdlephoneCheck(list) {
      showLoading();
      let res = await $api.gcdUser.post("batchAliMIdlephoneCheck", list);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success('提交成功');
        this.close();
        this.$emit('afterSave');
      } else {
                  this.$XModal.alert({
            message: "本次导入操作部分手机号出错，请前往导入记录查看！",
            status: "question",
          });
          this.close();
        // let data = res.data;
        // let message = '';
        // if (data.length > 0) {
        //   data.map(i => {
        //     message = message + i.failMsg + '，' + '\n';
        //   })
        // }
        // if (message === '') {
        //   this.$XModal.alert({
        //     message: "接口异常",
        //     status: "error",
        //   });
        // } else {
        //   this.$Message.success('提交成功');
        //   this.close();
        //   this.$emit('afterSave', message);
        // }
      }
    },
    close() {
      this.tableData = [{
        no: 1,
        userCategoryStr: '司机',
        userName: null,
        realName: null,
        idcardNum: null,
        phoneNum: null,
        regisiterNum: null,
        password: md5("888999"),
        userType: 1,
        idcardFrontUrl: null,
        idcardBackUrl: null,
        drivingCardFrontUrl: null,
        drivingCardSubpageUrl: null,
        qualificationUrl: null,
      }];
    }
  }
}
</script>

<style scoped>
.select >>> .ivu-select-arrow {
  position: absolute;
  top: 50% !important;
  right: 8px !important;
  line-height: 1;
  transform: translateY(-50%);
  font-size: 14px;
  color: #808695;
  transition: all .2s ease-in-out;
}
</style>